var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103.1 98.1",
    style: {
      enableBackground: "new 0 0 103.1 98.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Ellipse_60_1_);}\n\t.st1{fill:url(#Trac\xE9_212_1_);}\n\t.st2{fill:url(#Trac\xE9_213_1_);}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "orderComplete",
    transform: "translate(-138.421 -191.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_220",
    transform: "translate(-4110.647 -4691.147)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_60_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3802.9041,
    y1: 5431.2515,
    x2: 3803.3862,
    y2: 5430.7695,
    gradientTransform: "matrix(36.518 0 0 -36.518 -134554.8125 203230.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9DD39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90CC1C"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    className: "st0",
    cx: 4328.1,
    cy: 4900.4,
    r: 18.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trac\\xE9_212_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3805.6631,
    y1: 5427.2476,
    x2: 3805.4541,
    y2: 5427.4766,
    gradientTransform: "matrix(31.3351 0 0 -28.569 -114906.0781 159962.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66BB00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66BB00"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_212",
    className: "st1",
    d: "M4342.9,4889.7l-14,14c-0.2,0.2-0.5,0.4-0.8,0.5c-0.2,0-0.4-0.1-0.5-0.2l-6.6-6.6 c-1.3-1.3-3.4-1.4-4.8-0.1c0,0-0.1,0.1-0.1,0.1c-1.3,1.2-1.5,3.2-0.3,4.5c0.1,0.1,0.1,0.1,0.2,0.2l16.2,16.2 c9.8-2.3,16-12.1,13.7-21.9C4345.4,4893.9,4344.4,4891.6,4342.9,4889.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trac\\xE9_213_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3802.7202,
    y1: 5426.1392,
    x2: 3803.2102,
    y2: 5425.4341,
    gradientTransform: "matrix(37.193 0 0 -25.7283 -137108.1406 144492.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B799D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#07485E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_213",
    className: "st2",
    d: "M4328.1,4910.9c-2.1,0-4-0.8-5.5-2.3l-6.6-6.6c-1.4-1.3-1.5-3.6-0.2-5c1.3-1.4,3.6-1.5,5-0.2 c0.1,0.1,0.2,0.1,0.2,0.2l6.6,6.6c0.3,0.3,0.7,0.3,1,0c0,0,0,0,0,0l17.5-17.5c1.4-1.3,3.7-1.2,5,0.2c1.2,1.4,1.2,3.4,0,4.8 l-17.5,17.5C4332.2,4910.1,4330.2,4910.9,4328.1,4910.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4168,
    y1: 71.3824,
    x2: 42.3411,
    y2: 71.3824,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 1.8 102.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    style: {
      stopColor: "#FFDCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA9B1"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.1,17.8c-2.2,0-3.9,1.8-3.9,3.9v11.9c0,3.9-1.8,7.5-4.9,9.8h20.2V29.2C45.5,22.9,40.4,17.8,34.1,17.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1896,
    y1: 32.6572,
    x2: 70.5437,
    y2: 32.6572,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 1.8 102.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    style: {
      stopColor: "#FFDCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFA9B1"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.5,48c0-4-3.3-7.3-7.3-7.3H31.7c-2.4,0-4.7,0.9-6.4,2.6c-3.6,3.4-8.5,5.5-13.8,5.6l0,0v41l0,0 c5.3,0.1,10.2,2.2,13.8,5.6c1.7,1.6,4,2.6,6.4,2.6h37.5c4,0,7.3-3.3,7.3-7.3c0-1.7-0.6-3.3-1.6-4.6c-1.2-1.5-1.2-3.6,0-5.1 c1-1.3,1.6-2.8,1.6-4.6c0-1.7-0.6-3.3-1.6-4.6c-1.2-1.5-1.2-3.6,0-5.1c1-1.3,1.6-2.8,1.6-4.6c0-1.7-0.6-3.3-1.6-4.6 c-1.2-1.5-1.2-3.6,0-5.1C75.9,51.4,76.5,49.8,76.5,48L76.5,48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.169,
    y1: 32.6574,
    x2: 75.5087,
    y2: 32.6574,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 1.8 102.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC2B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF89A8"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.5,48c0-4-3.3-7.3-7.3-7.3H61c4,0,7.3,3.3,7.3,7.3c0,1.7-0.6,3.3-1.6,4.6c-1.2,1.5-1.2,3.6,0,5.1 c1,1.3,1.6,2.8,1.6,4.6s-0.6,3.3-1.6,4.6c-1.2,1.5-1.2,3.6,0,5.1c1,1.3,1.6,2.8,1.6,4.6c0,1.7-0.6,3.3-1.6,4.6 c-1.2,1.5-1.2,3.6,0,5.1c1,1.3,1.6,2.8,1.6,4.6c0,4-3.3,7.3-7.3,7.3h8.2c4,0,7.3-3.3,7.3-7.3c0-1.7-0.6-3.3-1.6-4.6 c-1.2-1.5-1.2-3.6,0-5.1c1-1.3,1.6-2.8,1.6-4.6s-0.6-3.3-1.6-4.6c-1.2-1.5-1.2-3.6,0-5.1c1-1.3,1.6-2.8,1.6-4.6 c0-1.7-0.6-3.3-1.6-4.6c-1.2-1.5-1.2-3.6,0-5.1C75.9,51.4,76.5,49.8,76.5,48z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.5793,
    y1: 32.6572,
    x2: 15.0621,
    y2: 32.6572,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 1.8 102.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2FBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#FAF7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3EAE6"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M8.6,95V43.8h3.7c3.2,0,5.8,2.6,5.8,5.8v39.5c0,3.2-2.6,5.8-5.8,5.8H8.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.1859,
    y1: 32.6572,
    x2: 9.9198,
    y2: 32.6572,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 1.8 102.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01D0FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    style: {
      stopColor: "#26A6FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0182FC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0,94.4V44.5c0-2.1,1.7-3.7,3.7-3.7c3.2,0,5.8,2.6,5.8,5.8v45.7c0,3.2-2.6,5.8-5.8,5.8 C1.7,98.1,0,96.4,0,94.4L0,94.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderComplete);
export default __webpack_public_path__ + "static/media/orderComplete.f65f64a9.svg";
export { ForwardRef as ReactComponent };